import ArtifactProvider from '@/components/canvas/CanvasElementSourceProviders/ArtifactProvider';

class LongTimeExposureAnnotationProvider extends ArtifactProvider {
  constructor(settings) {
    super(settings, 'longTimeExposureAnnotation');
  }
}

export default LongTimeExposureAnnotationProvider;
